import React from 'react';

import {GreenIcon, BlueIcon, GrayIcon} from '../svg/iconsSvg';

const NuInsStepper = ({labels, activeStep, steps}) => {
    const stepsArray = [...Array(steps).fill('')];
    const maxWidth = 80;
    const lineWidth = stepsArray.length > 0 ? maxWidth / (stepsArray.length - 1) +'%' : 0;
    const lineStyles = {width: lineWidth};
    const labelWidth = (100 - maxWidth) + '%';

    const renderIcon = (step) => {
        if(activeStep === step) {
            return <BlueIcon size="28px" />
        } else if (activeStep > step) {
            return <GreenIcon size="28px" />
        }
        return <GrayIcon size="28px" />
    }

    const renderLabelStyles = (step) => {
        if(activeStep === step) {
            return {width: labelWidth , color: '#3D4D9E', fontWeight: '600'};
        } else if (activeStep > step) {
            return {width: labelWidth , color: '#3D4D9E'};
        }
        return {width: labelWidth};
    }

    const renderLabels = () => {
        if(labels && labels.length) {
            return (
                <div className="stepper_steps-labels">
                    { labels.map((label, index) => {
                        return <p className="stepper_label" style={renderLabelStyles(index + 1)} key={index}>{label}</p>
                    })}
                </div>
            )
        }

        return null;
    }

    return (
        stepsArray.length > 0 
        ? (
            <div className="stepper">
                <div className="stepper_steps-icons">
                { stepsArray.map((step, index) => (
                        <div className="stepper_steps-step" style={index > 0 ? lineStyles : null} key={index}>
                            {index > 0 ? <div className="stepper_line" ></div> : null}
                            <div className="icon_text" step={index + 1} > 
                                {renderIcon(index+1)}
                            </div>
                        </div>
                    ))}
                </div>
                {renderLabels()}
            </div>
        )
        : ("")
    )
}

export default NuInsStepper